var loginFormModule = function(){
	var scope = ".js-mod-my-reviews";
	ui.ready(
        scope,
		function($mod){




		}
	);
}();

